import React from 'react';
import { Checkbox, Tooltip } from '@mui/material';
import { useRateControllerContext } from '../rateController/RateControllerContext';
import type { RateCode } from '../rateController/rateControllerModel';

type Props = { code: RateCode; label?: string };

export const RateFieldCheckbox = ({ code, label = 'Admin controls this value' }: Props) => {
  const { isControlled, toggle } = useRateControllerContext();
  const checked = isControlled(code);

  return (
    <Tooltip title="Checked: admin controls this value. Unchecked: the system computes it.">
      <Checkbox
        size="small"
        checked={checked}
        onChange={() => toggle(code)}
        inputProps={{ 'aria-label': label }}
      />
    </Tooltip>
  );
};
